import { queryOptions, useQuery } from '@tanstack/react-query';
import { getPlatformBalances, mapPlatformBalances } from '@/services/api/platform-balances';

export const PLATFORM_BALANCES_QUERY_KEY = ['system', 'balances'] as const;

export const platformBalancesQueryOptions = () =>
  queryOptions({
    queryKey: PLATFORM_BALANCES_QUERY_KEY,
    queryFn: getPlatformBalances,
    select: mapPlatformBalances,
  });

export const usePlatformBalances = () => useQuery(platformBalancesQueryOptions());
